import FounderList from './list'
import Title from './title'

const Founders = ({
  founders
}) => {
  const base = 'relative w-full flex flex-col md:flex-row justify-between gap-x-largeMobile lg:gap-x-largeDesktop mt-mediumDesktop lg:mt-largeDesktop'

  return (
    <div className={base}>
      <Title text={founders.title} />
      <FounderList founderList={founders.cards} />
    </div>
  )
}

export default Founders
